import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import axios from 'axios';

export default {
  namespaced: true,
  state: {
    zoom: {token: '', seq: 0, state: null, connectedMessage: "live captions by Textify"}
  },
  mutations: {
    setZoomToken(state,payload){
      state.zoom.token = payload.token
      state.zoom.seq = 0
    },
    setZoomState(state,payload){
      state.zoom.state = payload.state
    },
    increaseZoom(state){
      state.zoom.seq++
    },
  },
  actions: {
    setZoomToken({state,dispatch,commit},payload){
      commit('setZoomToken',payload)
      dispatch('postCaptionZoom',{message: {user: {name: 'Connected'}, message: state.zoom.connectedMessage}})
    },
    postCaptionZoom({state,commit},payload) {
      if(state.zoom.token.length){
        let lang = 'en-US'
        let url = 'https://ir-cors.herokuapp.com/' + state.zoom.token + '&seq=' + state.zoom.seq + '&lang=' + lang

        const options = {
          method: 'POST',
          headers: { 'content-type': 'text/plain' },
          data: payload.message.user.name + ": " + payload.message.message,
          url
        };
        axios(options)
        .then(function () {
          commit('setZoomState',{state: true})
        })
        .catch(function () {
          commit('setZoomState',{state: false})
        });

        commit('increaseZoom')

      }
    }
  },
  getters: {
  },
}
